import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import umanizzaDataSenzaOre from '../interfaccia/funzioniComuni/umanizzaDataSenzaOre';

function ListaSemplice({ data, tipoQuery }) {
    
    const [rows, setRows] = useState(
        data
      )

      useEffect(() => {
        setRows(data)
      }, [data]);


      const colonnaUniversale = function (nomeDato, labelDato, width, sortable, hide, reorder, conditionalCellStyles, ignoreRowClick, sortField, compact) {
        return ({
          selector: row => row[nomeDato],
          name: labelDato,
          sortable: sortable,
          hide: hide,
          reorder: reorder,
          width: width + "px",
          conditionalCellStyles: conditionalCellStyles,
          ignoreRowClick: ignoreRowClick,
          sortField: sortField,
          compact: compact
        })
      }

      const colonnaData = function (nomeDato, labelDato, width, sortField) {
        return ({
          selector: row => row[nomeDato],
          name: labelDato,
          sortable: true,
          sortField: sortField,
          reorder: true,
          width: width + "px",
          format: (row) => {
            if (row[nomeDato] == null) {
              return '';
            }
            return `${umanizzaDataSenzaOre(row[nomeDato])}`;
          }
        }
        )
      }
    
      const colonnaImporto = function (nomeDato, labelDato, width, sortField) {
        return ({
          selector: row => row[nomeDato],
          name: labelDato,
          sortable: true,
          reorder: true,
          sortField: sortField,
          width: width + "px",
          format: row => {
            if (row[nomeDato] == null) {
              return '';
            }
            const number = parseFloat(row[nomeDato]).toFixed(2)
            const numComma = number.toString().replace(".", ",")
            return `${numComma} €`;
          }
        }
        )
      }
    
      const columnsCorrispettiviMese = [
        //nomeDato,labelDato,width,sortable,hide,reorder,conditionalCellStyles,ignoreRowClick, sortField, compact
        colonnaUniversale('Paese di provenienza', 'Nazione', 150, true, false, true, false, false, 'clif.`Paese di provenienza`', false),
        colonnaData('Data_partenza', 'Data partenza', 130, 'sped.Data_partenza'),
        colonnaImporto('SommaDiTot_imp_spedizione', 'Somma importi', 140, false),
        colonnaUniversale('Numero scontrini', 'N. scontrini', 100, true, false, true, false, false, false, true)
      ]

      const columnsCorrispettiviMeseRimborsi = [
        colonnaUniversale('Paese di provenienza', 'Nazione', 150, true, false, true, false, false, 'clif.`Paese di provenienza`', false),
        colonnaData('Data_operazione', 'Data operazione', 130, 'resi.Data_operazione'),
        colonnaImporto('SommaDiTotale_rimborso', 'Somma importi', 140, false),
        colonnaUniversale('Numero rimborsi', 'N. rimborsi', 100, true, false, true, false, false, false, true)
      ]

      const columnsCorrispettiviMeseArticoli = [
        colonnaUniversale('tipo', 'Tipo articolo', 150, true, false, true, false, false, false, false),
        colonnaImporto('imp', 'Somma importi', 140, false),
        colonnaUniversale('num', 'Numero ordini', 100, true, false, true, false, false, false, true)
      ]

      let columns = columnsCorrispettiviMese

      if (tipoQuery === "corrispettiviMeseRimborsi") {
        columns = columnsCorrispettiviMeseRimborsi
      } else if (tipoQuery === "corrispettiviTipoArticoli") {
        columns = columnsCorrispettiviMeseArticoli
      }

      if (rows.length>1) {
        return (
          <DataTable
          data={rows}
          columns={columns}
          striped
          noDataComponent={<h3 className='ma5 pa5'>Nessun ordine risponde alla tua ricerca.</h3>}
          progressComponent={<h3 className='ma5 pa5 '>carico i dati...</h3>}
          pagination
        />
        )
      } else {
        return(
          <div className='tc pa4 b'>
            Nessun dato trovato.
          </div>
        )
      }
    
}

export default ListaSemplice;
